import React from "react"
import { useTranslation } from "react-i18next"

const EmptyState = () => {
  const { t } = useTranslation()
  return (
    <div className="flex-1 flex items-center justify-center bg-white">
      <div className="text-center max-w-sm px-6">
        <div className="w-28 h-28 mx-auto mb-5 bg-slate-100 rounded-full flex items-center justify-center">
          <svg
            className="w-16 h-16 text-slate-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-slate-700 mb-2">
          {t("admin.select_chat_to_get_started")}
        </h2>
        <p className="text-slate-400 text-sm">
          {t("admin.select_existing_conversation_or_start_new_one")}
        </p>
      </div>
    </div>
  )
}

export default EmptyState
